<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputSelect v-model="data"
                 :args="args"
                 :db="db"
                 :errors-post="errorsPost"
                 :js-errors="jsErrors"
                 :no-save="noSave"
                 :options="addressOccupancyOptions"
                 :skipped="skipped"
                 @jsErrors="jsErrors=$event"
                 @serverErrors="serverErrors=$event"
                 @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import {addressOptions} from "../../options/address";

import QuestionBase from "../../QuestionBase";
import InputSelect from "../../inputs/InputSelect";

export default {
  name: 'PreviousAddressOccupancy',
  mixins: [
    addressOptions,
    questionLoadHelpers
  ],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'What was your occupancy status?',
        subTitle: null,
        tip: null,
      },
      db: {
        saveLocation: 'client_previous_address',
        saveField: 'occupancy',
        objectId: this.objectId
      },
      args: {
        taggable: false,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-66'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>